import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

function DeleteUserDialog({
  deleteUserDialogOpen,
  setDeleteUserDialogOpen,
  selectedUser,
  deleteUserLoading,
  handleConfirmDeleteUser,
}) {
  return (
    <Dialog
      open={deleteUserDialogOpen}
      onClose={() => setDeleteUserDialogOpen(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ backgroundColor: "error.light", color: "white" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <DeleteIcon />
          Confirm Deletion
        </Box>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <DialogContentText>
          Are you sure you want to delete{" "}
          <strong>
            {selectedUser?.lawfirm_user_name
              ? selectedUser.lawfirm_user_name
              : "this user"}
          </strong>
          {""}? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button
          onClick={() => setDeleteUserDialogOpen(false)}
          variant="outlined"
          disabled={deleteUserLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirmDeleteUser}
          color="error"
          variant="contained"
          disabled={deleteUserLoading}
        >
          {deleteUserLoading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Delete"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteUserDialog;
